import { View } from "@react-pdf/renderer";
import {
  ResumePDFSection,
  ResumePDFText,

} from "components/Resume/ResumePDF/common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeLanguage } from "lib/redux/types";
import {
  ResumePDFDescription,
  TemplateNineteenPDFSection,
  TemplateNineteenSectionWithSubsections,
} from "./common";

export const Language = ({
  heading,
  languages,
  themeColor,
  isPDF,
}: {
  heading: string;
  languages: ResumeLanguage[];
  themeColor: string;
  isPDF: boolean;
}) => {
  return (
    <TemplateNineteenSectionWithSubsections themeColor={themeColor} heading={heading}>
      {languages.map(({ language, level, descriptions }, idx) => (
        <View key={idx} wrap={false}>
          <View
            style={{
              ...styles.flexRowBetween,
              marginTop: spacing["0.5"],
            }}
          >
            <View
              style={{
                ...styles.flexRow,
                gap: spacing["2"],
              }}
            >
              <ResumePDFText themeColor="black" bold={true}>
                {language}
              </ResumePDFText>
              <ResumePDFText themeColor="black">{level}</ResumePDFText>
            </View>
          </View>
          <View style={{ ...styles.flexCol, marginTop: spacing["0.5"] }}>
            <ResumePDFDescription items={descriptions} />
          </View>
        </View>
      ))}
    </TemplateNineteenSectionWithSubsections>
  );
};
